import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const data = {
  performanceIndexChartData: {},
  pILegendData: [],
  pIDisplayMode: 'single',
  pIPageMaxPercent: 0,
  pIPageMaxDecimal: 0,
};

export default {
  namespaced: true,
  state: data,
  getters,
  mutations,
  actions,
};
